/* eslint no-eval: 0 */
import _ from 'lodash';
import moment from 'moment';
import React, { cloneElement, Fragment, useEffect, useState } from 'react';
//style={{ color: 'purple' }}
import { CreateButton, Datagrid, FunctionField, List, sanitizeListRestProps, ShowButton, TextField, TopToolbar, useListContext } from 'react-admin';
import FiltreVersement from '../filtres/FiltreVersement';
//import ExportAgExp from './ExportAgExp';
import PostPagination from '../paginations/pagination';
import { MontantField } from '../references.js';
import rowStyleVst from '../styles/rowStyleVst';
import ValiderVstButton from './ValiderVstButton';

const style={marginLeft:15,marginTop:5}

 const  ListVersement=(props)=>{


    //const [fullname, setFullname] = useState('');
    //const [currentDate, setCurrentDate] = useState();
    const currentDate = moment().format().slice(0,10);
    const fullname=localStorage.getItem('fullname');

 return(
    
//filterDefaultValues={{"start_date":currentDate,"end_date":currentDate,status:"ATTENTE"}} 
        <List {...props}  
                bulkActionButtons={<PostBulkActionButtons />}
                actions={<ListActions />}
                filters={<FiltreVersement />} 
                pagination={<PostPagination />}
                sort={{ field: 'id', order: 'DESC' }}
                title={'Versement - '+fullname}
                empty={false}
                filterDefaultValues={{"start_date":currentDate,"end_date":currentDate}} 
            >
            
            <Datagrid rowStyle={rowStyleVst} optimized >
                <TextField source="code" label="Code" style={{ color: 'purple'  }} />
                <TextField source="type_vst" label="Versement"/>
                <TextField source="mode_vst" label="Mode"/>
                <MontantField source="montant"/>
                <TextField source="status" label="Status" />
                <TextField source="created_by_name" label="Crée par" />
                <TextField source="recep_by_name" label="Reception par" />
                <TextField source="vst_created_date" label="Date création"  sortBy="vst_created_date"/>
                <TextField source="vst_last_modified_date" label="Date revue" sortBy="vst_last_modified_date"/>
                <TextField source="commentaire" label="Commentaire"/>
                <FunctionField render={record =>(record.type_vst==='Reçu' && record.status==='ATTENTE') ?  <ValiderVstButton data={{id:record.id,montant:record.montant+' '+record.devise}} /> :  null } />
                <ShowButton />
            </Datagrid>
        </List>
       ) ;
    };



export default ListVersement;

const PostBulkActionButtons = props => {
    const { data, selectedIds } = useListContext();

    const res=calcul_selectedValues(selectedIds,data);
    const nf = new Intl.NumberFormat();

    return <Fragment>       
        {res.total_euros ? <p style={style}>Total EU : { nf.format(res.total_euros)}</p>:null}
        {res.total_fg? <p style={style}>Total FG  : { nf.format(res.total_fg)}</p>:null}
        {res.total_usd? <p style={style}>Total USD   : { nf.format(res.total_usd)}</p>:null}
    </Fragment>
};

const calcul_selectedValues=(selectedIds,myData)=>{

    if(selectedIds && selectedIds.length===0) return  {total_euros:0,total_fg:0,total_usd:0}
    const data=myData ? Object.values(myData):[];
    const records = data ? data.filter(record => selectedIds.includes(record.id)):[];
    const records_euros=records ? records.filter(record => record.devise==='EU'):[];
    const records_fg=records ? records.filter(record => record.devise==='FG'):[];
    const records_usd=records ? records.filter(record => record.devise==='USD'):[];

    var total_euros=records_euros.map(record=>eval(record.montant));
    var total_fg=records_fg.map(record=>eval(record.montant));
    var total_usd=records_usd.map(record=>eval(record.montant));

    total_euros = _.reduce(total_euros,function(memo, val) {
          return memo+val;
        });

    total_fg = _.reduce(total_fg,function(memo, val) {
          return memo+val;
        });
    
    total_usd = _.reduce(total_usd,function(memo, val) {
            //console.log(val.trans_amount);
             return memo+val;
        });

    return {total_euros:total_euros,total_fg:total_fg,total_usd:total_usd}
}

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter
    } = useListContext();
   
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button'
            })}
        
            <CreateButton basePath={basePath} />
        </TopToolbar>
    );
};

